import React from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { useGetModels } from '../../api/hooks/inventory';

export default function ModelsTable() {
  const { data: models } = useGetModels();
  return (
    <Paper variant="outlined" sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {models?.map((row, i) => {
              return (
                <TableRow hover tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

const columns = [
  {
    id: 'name',
    label: 'نام مدل',
    minWidth: 170,
  },
  {
    id: 'ram',
    label: 'رم',
    minWidth: 40,
    format: (count) => Number(count).toLocaleString('fa-IR'),
  },
  {
    id: 'memory',
    label: 'حافظه',
    minWidth: 40,
    format: (count) => Number(count).toLocaleString('fa-IR'),
  },
  // {
  //   id: 'brand',
  //   label: 'برند',
  //   minWidth: 70,
  //   format: (value) => value.name,
  // },
];
